import {
	OrderCancellationReasonEnum,
	OrderStatus,
} from "Infrastructure/Api/Api";
import { Resources } from "Infrastructure/Translation/Resources";
import type { OrderEditModel } from "Order/Components/Form/Schema/orderEditSchema";
import type { TOptions } from "i18next";
import type { ObjPathProxy } from "ts-object-path";
import { z } from "zod";

const orderValidationMessagesResource = Resources.base.order.validationMessages;

const validateDateDone = (
	data: OrderEditModel,
	ctx: z.RefinementCtx,
	t: (
		resourcePath: ObjPathProxy<unknown, string>,
		options?: TOptions,
	) => string,
) => {
	if (
		data.status === OrderStatus.done &&
		(!data.dateDone || data.dateDone.trim() === "")
	) {
		ctx.addIssue({
			code: z.ZodIssueCode.custom,
			message: t(orderValidationMessagesResource.dateDone),
			path: ["dateDone"],
		});
	}
};

const validateDateStarting = (
	data: OrderEditModel,
	ctx: z.RefinementCtx,
	t: (
		resourcePath: ObjPathProxy<unknown, string>,
		options?: TOptions,
	) => string,
) => {
	if (
		data.status === OrderStatus.confirmed &&
		(!data.dateStarting || data.dateStarting.trim() === "")
	) {
		ctx.addIssue({
			code: z.ZodIssueCode.custom,
			message: t(orderValidationMessagesResource.dateStarting),
			path: ["dateStarting"],
		});
	}
};

const validateCancellationReason = (
	data: OrderEditModel,
	ctx: z.RefinementCtx,
	t: (
		resourcePath: ObjPathProxy<unknown, string>,
		options?: TOptions,
	) => string,
) => {
	if (data.status === OrderStatus.cancelled) {
		const validCancellationReasons = Object.values(OrderCancellationReasonEnum);
		if (
			!data.cancellationReason ||
			!validCancellationReasons.includes(data.cancellationReason)
		) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: t(orderValidationMessagesResource.cancellationReason),
				path: ["cancellationReason"],
			});
		}
	}
};

type ValidateStatusParams = {
	data: OrderEditModel;
	ctx: z.RefinementCtx;
	t: (
		resourcePath: ObjPathProxy<unknown, string>,
		options?: TOptions,
	) => string;
};

export const validateStatus = ({ data, ctx, t }: ValidateStatusParams) => {
	validateDateDone(data, ctx, t);
	validateDateStarting(data, ctx, t);
	validateCancellationReason(data, ctx, t);
};
